// ============================================================
// LexNova — Spanish (ES) translations
// ============================================================
const es = {
  // ── Navigation ──────────────────────────────────────────
  nav: {
    inicio:       'Inicio',
    queGanas:     '¿Qué Ganás?',
    comoFunciona: '¿Cómo Funciona?',
    planes:       'Planes',
    misionVision: 'Misión & Visión',
    contacto:     'Contacto',
    empezar:      'Empezar',
  },

  // ── Home page ────────────────────────────────────────────
  home: {
    hero: {
      headline1: 'Automatizamos tus procesos y centralizamos tus mensajes',
      highlight: 'para que tu negocio responda y opere más rápido',
      headline2: ', sin complicaciones.',
      subtext:   'Con soluciones personalizadas, conviertes tareas repetitivas en eficiencia y más ventas.',
      cta:       'Agenda una demo',
    },
    futuro: {
      title:    'El futuro de tu operación',
    },
    features: [
      {
        id:          'automatizacion',
        title:       'Automatización',
        description: 'Elimina cuellos de botella operativos conectando tus herramientas clave. Deja que los flujos de trabajo inteligentes manejen lo rutinario mientras tú te enfocas en crecer.',
      },
      {
        id:          'agentes',
        title:       'Agentes IA',
        description: 'Implementa asistentes virtuales que entienden el contexto de tu negocio. Respuestas inmediatas, precisas y personalizadas 24/7 para tus clientes y equipo.',
      },
      {
        id:          'centralizacion',
        title:       'Centralización de mensajes',
        description: 'Unifica WhatsApp, correos, redes sociales y chat interno en un solo dashboard omnicanal. Nunca más pierdas el hilo de una conversación importante.',
      },
    ],
  },

  // ── ¿Qué Ganás? ─────────────────────────────────────────
  queGanas: {
  hero: {
    title: 'Potenciá tu negocio con',
    highlight: 'LexNova',
    subtext:
      'Descubrí las ventajas de integrar inteligencia artificial y automatización en tu día a día.',
  },
  cards: [
    {
      id: 'automatizar',
      title: 'Automatizar',
      description:
        'Procesos y tareas repetitivas, reduciendo tiempos y errores operativos en tu empresa.',
    },
    {
      id: 'ia',
      title: 'Inteligencia Artificial',
      description:
        'Asistentes virtuales con conversaciones naturales y humanizadas que mejoran la experiencia de tus clientes 24/7.',
    },
    {
      id: 'centralizar',
      title: 'Centralizar',
      description:
        'WhatsApp, Facebook e Instagram integrados en un solo panel de control unificado.',
    },
    {
      id: 'integrar',
      title: 'Integrar',
      description:
        'Agendas y gestores de tareas con flujos automáticos sincronizados en tiempo real.',
    },
    {
      id: 'desarrollar',
      title: 'Desarrollar',
      description:
        'Páginas web y landing pages de alto rendimiento para impulsar tu presencia digital y conversiones.',
    },
  ],
},

  // ── ¿Cómo Funciona? ─────────────────────────────────────
  comoFunciona: {
    hero: {
      tag:       'Arquitectura del Sistema',
      title1:    'La anatomía de un',
      highlight: 'Agente IA',
      subtext:   'Descubrí el proceso detrás de la automatización inteligente. Desde el análisis inicial hasta la integración perfecta con tus sistemas actuales.',
    },
    metodologia: {
      title:   'Metodología de Implementación',
      subtext: 'Un proceso estructurado para garantizar resultados tangibles y una integración sin fricciones.',
    },
    steps: [
      {
        id:          '01',
        title:       'Diagnóstico de tu negocio',
        description: 'Analizamos tus flujos de trabajo actuales e identificamos cuellos de botella ideales para automatizar.',
      },
      {
        id:          '02',
        title:       'Diseño del flujo automatizado',
        description: 'Mapeamos la lógica conversacional y las integraciones necesarias para un agente eficiente.',
      },
      {
        id:          '03',
        title:       'Implementación del agente IA',
        description: 'Desarrollamos, entrenamos y conectamos el modelo a tus plataformas (WhatsApp, Web, CRM).',
      },
      {
        id:          '04',
        title:       'Optimización continua',
        description: 'Monitoreamos el rendimiento, ajustamos prompts y expandimos capacidades según el uso real.',
      },
    ],
    capacidades: {
      title:   'Capacidades del Sistema',
      subtext: 'Interacciones diseñadas para convertir y retener.',
    },
    caps: [
      {
        id:          'welcome',
        tag:         'Recepción',
        title:       'Welcome Messages',
        description: 'Respuestas instantáneas y contextuales que inician la relación comercial al instante.',
        preview:     '¡Hola! 🤖 Soy Nova, el asistente virtual. ¿En qué te puedo ayudar hoy con tu negocio?',
        previewReply:'Quiero info sobre planes.',
      },
      {
        id:          'horario',
        tag:         '24/7',
        title:       'Asistencia Fuera de Horario',
        description: 'Tu negocio nunca duerme. Captura leads y resuelve dudas a cualquier hora.',
        preview:     '¿Están abiertos?',
        previewReply:'Actualmente nuestra oficina está cerrada, pero puedo tomar tus datos y un asesor te contactará a primera hora mañana. 🌙',
      },
      {
        id:          'seguimiento',
        tag:         'Proactivo',
        title:       'Seguimiento Automático',
        description: 'Re-engancha prospectos fríos o confirma citas sin intervención humana.',
      },
      {
        id:          'calificacion',
        tag:         'Feedback',
        title:       'Calificación de Conversación',
        description: 'Mide la satisfacción del cliente al instante para mejorar el modelo.',
        preview:     '¿Cómo calificarías la atención de nuestro agente?',
      },
    ],
  },

  // ── Planes ───────────────────────────────────────────────
  planes: {
  title: 'Planes diseñados para cada etapa',
  subtext:
    'Elige el nivel de automatización que mejor se adapta a tu operación actual. Puedes comenzar simple y escalar cuando tu negocio lo requiera.',
  popular: 'MÁS POPULAR',
  cta: 'Agenda una demo',

  pricing: {
    proPromoPrice: '$13,499',
    proRegularPrice: '$17,500 + IVA/mes',
    proPromoPeriod: '+ IVA/mes por los primeros 3 meses',
    enterprisePriceLabel: 'A medida',
    enterprisePeriod: 'Cotización personalizada',
  },

  cardLabels: {
    selected: 'Seleccionado',
    seeMore: 'Selecciona para ver más',
    visible: 'Información visible',
    contactSales: 'Contactar ventas',
    proPromoNote: 'Promoción: paga como Lex Essential durante los primeros 3 meses.',
  },

  plans: [
    {
      id: 'personal',
      name: 'Lex Personal',
      tagline: 'Tu primer asistente inteligente para automatizar sin complicarte.',
      price: '$9,500',
      period: '+ IVA/mes',
      popular: false,
      features: [
        'Agente conversacional en WhatsApp',
        'IA entrenada con tus FAQs',
        'Google Calendar para citas',
        'Recordatorios básicos',
        'Webhooks simples',
        'Seguimiento operativo inicial',
      ],
    },
    {
      id: 'essential',
      name: 'Lex Essential',
      tagline: 'Automatización comercial para capturar y calificar oportunidades.',
      price: '$13,499',
      period: '+ IVA/mes',
      popular: false,
      features: [
        '1 canal: WhatsApp, Instagram o Facebook',
        'IA para respuestas y calificación',
        'Panel CRM básico',
        'Chatwoot centralizado',
        'Airtable o Google Sheets',
        'Meta Forms y exportación CSV/XLSX',
      ],
    },
    {
      id: 'pro',
      name: 'Lex Pro',
      tagline: 'Automatización avanzada para equipos que necesitan escalar.',
      price: '$17,500',
      period: '+ IVA/mes',
      popular: true,
      features: [
        'Precio Essential por 3 meses',
        'Omnicanalidad avanzada',
        'Flujos comerciales personalizados',
        'Integraciones premium',
        'Reportes y analítica',
        'Automatización entre etapas',
      ],
    },
    {
      id: 'enterprise',
      name: 'Lex Enterprise',
      tagline: 'Soluciones a medida para operaciones corporativas.',
      price: 'A medida',
      period: 'Cotización personalizada',
      popular: false,
      features: [
        'Desarrollo IA custom',
        'Integraciones empresariales',
        'Soporte dedicado',
        'SLA según operación',
        'Infraestructura personalizada',
        'Escalabilidad corporativa',
      ],
    },
  ],

  supplements: {
    personal: {
      eyebrow: 'Punto de entrada',
      title: 'Automatiza tareas operativas sin sistemas complejos',
      description:
        'Ideal para emprendedores, profesionales independientes y negocios con volumen bajo o medio de mensajes que quieren liberar tiempo sin implementar herramientas complejas.',
      details: [
        'Responde automáticamente desde un número de WhatsApp.',
        'Ayuda con citas, recordatorios y seguimiento básico.',
        'No incluye CRM, embudos de venta ni reportes avanzados.',
      ],
    },
    essential: {
      eyebrow: 'Para empezar a escalar',
      title: 'IA + panel CRM para filtrar prospectos',
      description:
        'Pensado para PyMEs con marketing activo y un equipo pequeño de ventas que necesita responder rápido, calificar leads y tener visibilidad del proceso comercial.',
      details: [
        'Centraliza conversaciones y oportunidades en un panel.',
        'Califica leads y exporta datos a Airtable, Sheets o CSV/XLSX.',
        'No incluye automatización avanzada, remarketing ni reportes detallados.',
      ],
    },
    pro: {
      eyebrow: 'Promoción activa',
      title: 'Lex Pro por precio Essential durante 3 meses',
      description:
        'Una opción para negocios que ya necesitan más canales, mejores integraciones y automatización comercial más profunda desde el inicio.',
      details: [
        'Precio promocional de $13,499 + IVA/mes durante los primeros 3 meses.',
        'Después continúa con su precio regular de $17,500 + IVA/mes.',
        'Pensado para equipos que requieren flujos, reportes e integraciones más avanzadas.',
      ],
    },
    enterprise: {
      eyebrow: 'A medida',
      title: 'Contacta al departamento de ventas',
      description:
        'Para operaciones corporativas, el alcance técnico, infraestructura, integraciones y soporte se definen después de revisar tus procesos.',
      details: [
        'Diagnóstico técnico-comercial personalizado.',
        'Arquitectura IA custom para procesos específicos.',
        'Soporte dedicado, SLA e infraestructura personalizada.',
      ],
    },
  },
},

  // ── Misión & Visión ──────────────────────────────────────
  misionVision: {
    hero: {
      title1:    'El Propósito',
      highlight: 'LexNova',
      subtext:   'Diseñando el futuro de la automatización inteligente.',
    },
    mision: {
      label:       'Misión',
      description: 'Empoderar a las empresas para que automaticen sus procesos y mejoren la comunicación con sus clientes a través de soluciones de IA intuitivas y personalizadas.',
    },
    vision: {
      label:       'Visión',
      description: 'Convertirnos en el socio estratégico líder para empresas que buscan integrar la inteligencia artificial en su ADN, haciendo de la automatización una herramienta estándar, accesible y fundamental para el crecimiento digital.',
    },
  },

  // ── Contacto ─────────────────────────────────────────────
  contacto: {
    hero: {
      title1:    'Hablemos del',
      highlight: 'futuro',
      subtext:   'Estamos aquí para resolver tus dudas y ayudarte a dar el siguiente paso en la evolución de tu negocio.',
    },
    info: {
      slogan: 'Automatiza hoy. Escala mañana.',
      email:  'hola@lexnova.cloud',
      phone:  '+52 9996167830',
    },
    form: {
      nombre:    'Nombre completo',
      empresa:   'Empresa',
      correo:    'Correo electrónico',
      whatsapp:  'Número de WhatsApp',
      mensaje:   'Mensaje',
      placeholders: {
        nombre:   'Ej. Juan Pérez',
        empresa:  'Tu compañía',
        correo:   'juan@empresa.com',
        whatsapp: '+52 9996167830',
        mensaje:  '¿En qué podemos ayudarte?',
      },
      submit:    'Enviar Mensaje',
      success:   '¡Mensaje enviado! Te contactaremos pronto.',
    },
  },

  // ── Footer ───────────────────────────────────────────────
  footer: {
    copyright: '© 2024 LexNova. Automatiza hoy. Escala mañana.',
    links: {
      whatsapp:  'WhatsApp',
      instagram: 'Instagram',
      facebook:  'Facebook',
      website:   'www.lexnova.cloud',
    },
  },
} as const;

export default es;
